module.exports = __webpack_public_path__ + "static/google-play-badge_pl-081d4afa4ae586d2a5a0fcf5ffae28c9.svg";